import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { SessionExpiredService } from '../services/session-expired.service';

/** Código de negocio devuelto por la API cuando la sesión expira o fue cerrada. */
const SESSION_EXPIRED_CODE = 1003;

/**
 * Interceptor que detecta el código 1003 ("Autorización denegada: sesión expirada
 * o cerrada") y delega en {@link SessionExpiredService} para mostrar un alert-dialog
 * de SpartanUI. Al confirmar, el componente raíz cierra la sesión y redirige al login.
 *
 * La API de Sakoo entrega los errores de negocio dentro del cuerpo de la respuesta
 * (normalmente con HTTP 200), por lo que se inspecciona tanto el body exitoso como
 * el de las respuestas de error.
 */
export const sessionExpiredInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionExpired = inject(SessionExpiredService);

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          const body = event.body as { code?: number; message?: string } | null;
          if (body?.code === SESSION_EXPIRED_CODE) {
            // Se usa el mensaje amigable por defecto en lugar del técnico de la API.
            sessionExpired.show();
          }
        }
      },
      error: (err: HttpErrorResponse) => {
        const body = (err?.error ?? err) as { code?: number; message?: string };
        if (body?.code === SESSION_EXPIRED_CODE) {
          sessionExpired.show();
        }
      },
    })
  );
};
